import Requesttrans from '../../views/Requesttrans';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickSubmitHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/thanksPage`));
    },

    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/viewReport`));
    },

    clickFAQHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/faqpage`));
    }
  };
};

const RequesttransComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Requesttrans);

export default RequesttransComponent;



// WEBPACK FOOTER //
// ./src/components/container/Requesttrans/index.js